import { useState } from "react";

import { login } from "../data/auth";
import { PasswordField } from "./PasswordField";

export const LoginScreen = ({
  onLoggedIn,
  nextHref = "/app",
}: {
  onLoggedIn: (nextHref: string) => void;
  nextHref?: string;
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  return (
    <main className="miboard-auth-page">
      <form
        onSubmit={async (event) => {
          event.preventDefault();
          try {
            await login(email, password);
            onLoggedIn(nextHref);
          } catch (reason) {
            setError(
              reason instanceof Error
                ? reason.message
                : "Não foi possível entrar.",
            );
          }
        }}
        className="miboard-auth-card"
      >
        <img
          src="/image/Logo%20Miboard.png"
          alt="MiBoard"
          className="miboard-auth-logo"
        />
        <h1>Entrar</h1>
        <p className="miboard-auth-description">Acesse seus painéis.</p>
        <label className="miboard-auth-label">
          E-mail
          <input
            required
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="miboard-auth-input"
          />
        </label>
        <label className="miboard-auth-label">
          Senha
          <PasswordField
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            inputClassName="miboard-auth-input"
          />
        </label>
        <p className="miboard-auth-forgot">
          <a href="/app/forgot-password">Esqueceu sua senha?</a>
        </p>
        {error && <p className="miboard-auth-message">{error}</p>}
        <button className="miboard-auth-submit" type="submit">
          Entrar
        </button>
        <p className="miboard-auth-link">
          Ainda não tem conta? <a href="/app/signup">Criar conta</a>
        </p>
      </form>
    </main>
  );
};
